import React from "react";

export default function Footer() {
  return (
    <div className="mt-5 bg-slate-900 h-32 flex">
      <h1 className="font-medium text-white m-auto">
        &#169; Made with ❤️ by Saqib
      </h1>
    </div>
  );
}
